export const filterByExistingTranslation = (obj: Record<string, string>) => {
  const { t, te } = useI18n()
  return Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      ...(te(obj[key]) && { [key]: t(obj[key]) }),
    }),
    {}
  )
}
